const DELETE_FILE = (state, payload) => {
  if (state.submissionItem) {
    if (state.submissionItem && state.submissionItem.id === payload) {
      state.submissionItem.asset = undefined;
    }
  }
};

export default DELETE_FILE;
